import {ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild} from '@angular/core';
import { ApplicationStateService } from '../../../../services/application.state.service';
import { VisualizeEngine } from '@door-vision/visualisation-engine';
import { ScenarioImageService } from '../../../../services/scenario-image/scenario-image.service';
import { DoorService } from '../../../../services/door/door.service';
import { CustomerService } from '../../../../services/customer/customer.service';
import { AbstractVisualizePanelComponent } from '../../../../panels/abstract.visualize-panel.component';
import { TrackingService } from '../../../../services/tracking.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import {NgbModal, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-visualize-panel',
  templateUrl: './visualize-panel.component.html'
})
export class VisualizePanelComponent extends AbstractVisualizePanelComponent implements OnInit {

  @ViewChild('refineCornersTooltip') public refineCornersTooltip!: NgbTooltip;

  constructor(visualizeEngine: VisualizeEngine,
              scenarioImageService: ScenarioImageService,
              doorService: DoorService,
              renderer: Renderer2,
              cdRef: ChangeDetectorRef,
              customerService: CustomerService,
              applicationStateService: ApplicationStateService,
              trackingService: TrackingService,
              translationService: TranslateService,
              router: Router,
              modalService: NgbModal) {
    super(visualizeEngine, scenarioImageService, doorService, renderer, cdRef, customerService, applicationStateService, trackingService, translationService, router, modalService);
  }

  ngOnInit(): void {
    this.applicationStateService.getHasUploadedImage().subscribe((hasUploadedImage: boolean) => {
      try {
        if (this.refineCornersTooltip) {
          this.refineCornersTooltip.open()

          // Show tooltip for 4 seconds
          setTimeout(() => {
            try {
              this.refineCornersTooltip.close(true);
            } catch (e) {
              console.info('Could not close tooltip', e)
            }
          }, 4000)
        }
      } catch (e) {
        console.info('Could not open tooltip', e)
      }
    })
  }
}
